module.exports = __webpack_public_path__ + "static/media/banamex.07d14ea9.svg";